import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { useLocation } from "react-router-dom";
import { CalculationObservers, Observers } from "store/observers";
import { PageRoute } from "utility/url";
export var StoreProvider = function (_a) {
    var children = _a.children, store = _a.store, persistor = _a.persistor;
    var currentRoute = useLocation().pathname;
    var isSystemDesignPage = currentRoute === PageRoute.SYSTEM_DESIGN;
    return (_jsx(Provider, { store: store, children: _jsxs(PersistGate, { persistor: persistor, loading: null, children: [_jsx(Observers, {}), isSystemDesignPage && _jsx(CalculationObservers, {}), children] }) }));
};
